"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledHeroEventResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const hero_events_1 = require("../hero-events");
class ScheduledHeroEventResponseDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        Object.assign(this, options);
    }
    getFields() {
        return [
            'id',
            'calendarDay',
            'heroEvent',
            'studentScheduledHeroEvents',
            'startTime',
            'endTime'
        ];
    }
    id;
    calendarDay;
    heroEvent;
    studentScheduledHeroEvents;
    startTime;
    endTime;
}
exports.ScheduledHeroEventResponseDto = ScheduledHeroEventResponseDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], ScheduledHeroEventResponseDto.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ScheduledHeroEventResponseDto.prototype, "calendarDay", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", hero_events_1.HeroEventResponseDto)
], ScheduledHeroEventResponseDto.prototype, "heroEvent", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ScheduledHeroEventResponseDto.prototype, "studentScheduledHeroEvents", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ScheduledHeroEventResponseDto.prototype, "startTime", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ScheduledHeroEventResponseDto.prototype, "endTime", void 0);
